
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 15">
  <path
    d="M1.10801 0L0.0528 1.04475L6.33137 7.36639L0 13.6348L1.04629 14.6882L8.43274 7.37499L1.10801 0Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'ArrowRight',
    }) as DefineComponent
    </script>
    